import { SERVICES_REQUEST, ENDPOINT_REQUEST, sendMsg } from "../../configurations";

export const CAServices = {
  getShareHoldersEquityService,
  shareHoldersEquityConfirmService,
  enquiryShareHoldersEquityService,
  inputShareHoldersEquityService
}

function getShareHoldersEquityService(params, callback) {
  sendMsg(SERVICES_REQUEST.CA, ENDPOINT_REQUEST.iCA.SHARE_HOLDERS_EQUITY_LIST, params).get(res => {
    callback(res);
  })
}

function shareHoldersEquityConfirmService(params, callback) {
  sendMsg(SERVICES_REQUEST.IPO, ENDPOINT_REQUEST.iCA.SHARE_HOLDERS_EQUITY_CONFIRM, params).post(res => {
    callback(res);
  })
}

function enquiryShareHoldersEquityService(params, callback) {
  sendMsg(SERVICES_REQUEST.CA, ENDPOINT_REQUEST.iCA.SHARE_HOLDERS_EQUITY_ENQUIRY, params).get(res => {
    callback(res);
  })
}

function inputShareHoldersEquityService(params, callback) {
  sendMsg(SERVICES_REQUEST.CA, ENDPOINT_REQUEST.iCA.SHARE_HOLDERS_EQUITY_INPUT, params).post(res => {
    callback(res);
  })
}